import { HttpInterceptorFn } from '@angular/common/http';
import { AUTH_TOKEN_KEY } from 'src/app/config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY) || '';
  req = req.clone({
    setHeaders: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  return next(req);
};
